module.exports = __webpack_public_path__ + "static/media/osc_balz.4e4d6f13.png";